var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg529EducationAccounts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21350_8913)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4475 9.8877C10.447 9.8877 10.4465 9.8877 10.4461 9.8877C10.2948 9.8877 10.1525 9.94669 10.045 10.0539C9.93632 10.1623 9.87646 10.3066 9.87646 10.4602V19.0456C9.87646 19.3604 10.1336 19.6172 10.4497 19.618C11.7824 19.6212 14.0152 19.8989 15.5555 21.5108V12.526C15.5555 12.4193 15.5283 12.3191 15.4768 12.2361C14.2126 10.2002 11.7832 9.89082 10.4475 9.8877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1236 19.0457V10.4602C22.1236 10.3066 22.0637 10.1623 21.9551 10.0539C21.8476 9.94669 21.7051 9.8877 21.554 9.8877C21.5535 9.8877 21.553 9.8877 21.5526 9.8877C20.2169 9.89087 17.7875 10.2002 16.5232 12.2361C16.4718 12.3191 16.4446 12.4194 16.4446 12.5261V21.5108C17.9849 19.8989 20.2177 19.6212 21.5504 19.618C21.8664 19.6172 22.1236 19.3604 22.1236 19.0457Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4275 11.8672H23.0123V19.0452C23.0123 19.849 22.3574 20.5045 21.5523 20.5065C20.4219 20.5092 18.5581 20.7302 17.238 21.9795C19.521 21.4206 21.9277 21.7839 23.2993 22.0965C23.4706 22.1355 23.6475 22.0952 23.7848 21.9858C23.9215 21.8768 23.9999 21.7137 23.9999 21.5387V12.4396C24 12.124 23.7431 11.8672 23.4275 11.8672Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.98759 19.0452V11.8672H8.57245C8.25686 11.8672 8 12.124 8 12.4396V21.5385C8 21.7136 8.07844 21.8766 8.21517 21.9857C8.35227 22.095 8.52908 22.1354 8.70061 22.0963C10.0722 21.7837 12.4789 21.4204 14.7618 21.9794C13.4419 20.7301 11.578 20.5091 10.4476 20.5064C9.64256 20.5045 8.98759 19.849 8.98759 19.0452Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21350_8913"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(8 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg529EducationAccounts);
export default __webpack_public_path__ + "static/media/529_education_accounts.70966346f64e8c38230c92b8a519f96f.svg";
export { ForwardRef as ReactComponent };